
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/etica-e-compliance",
      function () {
        return require("private-next-pages/etica-e-compliance/index.js");
      }
    ]);
  